export class TypeInventoryModel {
  typeInventoryId: number = 0;
  name: string = '';
  code: number = 0;
}
